import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { admTargetRevenueStatsByArticleMainGroup } from "../utils/admTargetRevenueStatsByArticleMainGroup"

export const queryAdmRevenueTargetByArticleMainGroup = {
  async admRevenueTargetByArticleMainGroup(parent, args, context, info) {
    const { year = new Date().getFullYear(), admNumber } = args

    const user = context?.user

    await checkPermissions({
      user,
      admNumber,
      domainObject: DomainObjects.REVENUES,
      operation: Operations.READ,
    })

    const { summary, admStats } = await admTargetRevenueStatsByArticleMainGroup({
      admNumber,
      year,
    })

    return { summary, revenueStats: admStats }
  },
}
